import { PureComponent } from 'react';
import styled from 'styled-components/native';

import { CatItem } from '../../../types/CatsResponse';
import CategoryItem from './CategoryItem';

export interface Props {
  categoryPair: CatItem[];
  layoutName: string;
  index: number;
  shouldDisplayImpressionForDebug: boolean;
}

export default class CategoryPair extends PureComponent<Props> {
  static defaultProps = {
    shouldDisplayImpressionForDebug: false,
  };

  renderCategory = (item: CatItem, index: number, pairIndex: number) => {
    const { layoutName, shouldDisplayImpressionForDebug } = this.props;

    return (
      <CategoryItem
        item={item}
        pairIndex={pairIndex}
        index={index}
        layoutName={layoutName}
        shouldDisplayImpressionForDebug={shouldDisplayImpressionForDebug}
      />
    );
  };

  render() {
    const { categoryPair, index } = this.props;

    return (
      <S.Container testID={`categoryPair_${index}`}>
        {this.renderCategory(categoryPair[0], index, 0)}
        {this.renderCategory(categoryPair[1], index, 1)}
      </S.Container>
    );
  }
}

const S = {
  Container: styled.View`
    margin: 0 18px;
  `,
};
